import { offerPlacementSummarySchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import { OfferNetworkProvider } from "@redotech/order-tracking-common/tracking-page-definition";
import { OfferPlacementSurface } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createOfferPlacement = {
  name: "createOfferPlacement" as const,
  input: z.discriminatedUnion("provider", [
    z.object({
      provider: z.literal(OfferNetworkProvider.FALCON),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
      isLiveMode: z.boolean().default(false),
    }),
    z.object({
      provider: z.literal(OfferNetworkProvider.ROKT),
      name: z.string().min(1),
      surface: createEnum(Object.values(OfferPlacementSurface)),
      pageIdentifier: z.string().min(1),
      sandbox: z.boolean(),
    }),
  ]),
  output: z.object({ placement: offerPlacementSummarySchema }),
};
